import { apiEndpoints } from 'settings/_apiSettings'

interface RequestData {
  body: BodyInit | null | undefined; // whatewer you've put in the init.body in fetch(url, init) or xhr.send(body)
  headers: Record<string, string>;
}

interface ResponseData {
  body: string | unknown | null;
  headers: Record<string, string>;
}

interface RequestResponseData {
  readonly status: number;
  readonly method: string;
  url: string;
  request: RequestData;
  response: ResponseData;
}

const baseUrl = process.env.REACT_APP_API_URL
const medicalRecordFormsUrl = '/v0/medical-record/forms/'
const patientsUrl = '/v0/patients/'
const authUrl = `${baseUrl}${apiEndpoints.AUTH}`
const changePasswordUrl = '/password/'

const signupUrls = [
  `${baseUrl}${patientsUrl}corporate/`,
  `${baseUrl}${patientsUrl}capitation/`,
  `${baseUrl}${patientsUrl}enterprise/`,
  `${baseUrl}${patientsUrl}particular/`,
]

export function sanitizer(data: RequestResponseData) {
  if (data.url === authUrl && typeof data.request.body === 'string') {
    try {
      const body = JSON.parse(data.request.body)
      if (body.password) {
        body.password = '<SANITISED>'
        data.request.body = JSON.stringify(body)
      }
    // eslint-disable-next-line no-empty
    } catch {}
  }

  if (data.url.includes(changePasswordUrl) && typeof data.request.body === 'string') {
    try {
      const body = JSON.parse(data.request.body)
      if (body.password) {
        body.password = '<SANITISED>'
        data.request.body = JSON.stringify(body)
      }
    // eslint-disable-next-line no-empty
    } catch {}
  }

  if (data.url.includes(medicalRecordFormsUrl) && typeof data.request.body === 'string') {
    try {
      data.request.body = '<SANITISED>'
    // eslint-disable-next-line no-empty
    } catch {}
  }

  if (signupUrls.includes(data.url) && typeof data.request.body === 'string') {
    try {
      data.request.body = '<SANITISED>'
    // eslint-disable-next-line no-empty
    } catch {}
  }

  try {
    if (data.status < 400 && (data.response.body as any).data.jwt) {
      (data.response.body as any).data.jwt = '<TOKEN>'
    }
    // eslint-disable-next-line no-empty
  } catch {}

  try {
    if (data.status < 400 && (data.response.body as any).form.uuid) {
      (data.response.body as any).form = '<PRONTUÁRIO>'
    }
  // eslint-disable-next-line no-empty
  } catch {}

  return data
}